/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterESmall = createReactComponent("outline", "letter-e-small", "IconLetterESmall", [["path", { "d": "M14 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M10 12h2.5", "key": "svg-1" }]]);

export { IconLetterESmall as default };
//# sourceMappingURL=IconLetterESmall.mjs.map
